import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import "react-datepicker/dist/react-datepicker.css";
import ChartFromServer from '../../../Components/Charts/ChartFromServer';
import AgTable from '../../../Components/Table/AgTable';

export default function IndicadoresVentaGeneral({ title }) {
    const header = [
        {
            headerName: 'Mall',
            field: 'mall',
            
        },
        {
            headerName: 'Acumulado mes',
            field: 'ventaMensual',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMensual, true)}</>
            )
        },
        {
            headerName: 'Meta Mes',
            field: 'metaMensual',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.metaMensual, true)}</>
            )
        },
        {
            headerName: 'Cumplimiento',
            field: 'cumplimiento',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.cumplimiento)}</>
            )
        },
        {
            headerName: 'Acumulado año',
            field: 'ventaAcumulada',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaAcumulada, true)}</>
            )
        },
        {
            headerName: 'Meta año',
            field: 'metaAnual',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.metaAnual, true)}</>
            )
        },
        {
            headerName: 'Cumplimiento',
            field: 'cumplimientoAcumulada',
            headerClassName: 'text-gray-800 mb-1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.cumplimientoAcumulada)}</>
            )
        }
    ]

    const animatedComponents = makeAnimated();

    const [auxData, setAuxData] = useState({ montoVenta: null, fecha: null });

    const [tipoReporte, setTipoReporte] = useState({
        "value": "ventaMensual",
        "label": "Venta Mensual"
    });
    let tipoReportesList = {
        "defaultId": "ventaMensual",
        "list": [{
            "value": "ventaMensual",
            "label": "Venta Mensual"
        },
        {
            "value": "ventaMensualM2",
            "label": "Venta Mensual m2"
        }]
    };

    const getOptionValueTipoReporte = idDefault => {
        return tipoReportesList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeTipoReporte = (inputValue) => {
        setTipoReporte(inputValue);
    }

    const colorList = [
        "#4472C4",
        "#4472C4",
        "#F64E60",
        "#F64E60"
    ];

    const settings = {
        "disableTooltipX": false,
        "disableTooltipY": false,
        "disableLabelX": false,
        "disableLabelY": false,
        "tooltipDy": 0,
        "tooltipAft": "",
        "enableBullet": true,
        "circleBulletRadius": 5,
        "enableLegend": true,
        "widthColumn": 1,
        "strokeWidth": 2,
        "timeTotalAnimation": 20,
        "exportar": true,
        "titleYizq": "",
        "titleYder": "",
        "labelAdapterAxisYIzq": "",
        "labelAdapterAxisYDer": ""
    }

    const dataSeries = [
        {
            "name": "Monto Año Actual",
            "field": "montoAnioActual",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        },
        {
            "name": "Monto Año Pasado",
            "field": "montoAnioPasado",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        }
    ];

    const token = useGetToken();

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.DASHBOARD_MALL]} >
                <PageTitle>{title}</PageTitle>
                <div className="d-flex flex-wrap flex-stack mb-6">

                    <h3 className="fw-bolder my-2">Tipo Reporte
                    </h3>

                    <div className="d-flex flex-wrap my-2">
                        <div className="me-4" style={{ minWidth: "200px" }}>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValueTipoReporte(tipoReportesList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={tipoReportesList.list}
                                onChange={(onChangeTipoReporte)}
                            />
                        </div>
                    </div>

                </div>


                <div className='card card-flush'>

                    <div className='card-body pt-6'>

                        <div className='flex-grow-1 pb-0'>

                            <div className="me-2">
                                <div className="text-dark text-hover-primary fw-bolder fs-3"> Venta
                                    {tipoReporte.value === "ventaMensualM2" && <span> por m<sup>2</sup></span>}
                                    <span> del {auxData.fecha}</span>
                                </div>
                                <div className="text-muted fs-7 fw-bold">A nivel nacional</div>
                            </div>
                            <div className="fw-bolder fs-3 text-primary"> S/ {Utilities.comillasFix(auxData.montoVenta)}</div>
                        </div>

                        {
                            tipoReporte.value === "ventaMensual" &&
                            <>
                                <AgTable
                                    idContent={"IndicadoresVentaGeneralMes"}
                                    apiService={Api.IndicadoresVentaGeneralMes}
                                    setAuxData={setAuxData}
                                    header={header}
                                    fileNameDownload={"Indicadores Venta General Mes"}
                                    conditions={true}
                                    args={{ token: token }}
                                    hideFilter={true}
                                    paginationPageSize={8}
                                />
                            </>
                        }

                        {
                            tipoReporte.value === "ventaMensualM2" &&
                            <>
                                <AgTable
                                    idContent={"IndicadoresVentaGeneralMesM2"}
                                    apiService={Api.IndicadoresVentaGeneralMesM2}
                                    setAuxData={setAuxData}
                                    header={header}
                                    fileNameDownload={"Indicadores Venta General Mes M2"}
                                    conditions={true}
                                    args={{ token: token }}
                                    hideFilter={true}
                                    paginationPageSize={8}
                                />
                            </>
                        }
                    </div>
                </div>

                <div className="card my-5">
                    <div className="card-header border-0 pt-5">
                        <div className="d-flex align-items-center mb-3">
                            {tipoReporte.value === "ventaMensual" && <h4>Ventas Totales del Mes</h4>}
                            {tipoReporte.value === "ventaMensualM2" && <h4>Ventas Totales por m<sup>2</sup> del Mes</h4>}
                        </div>
                    </div>

                    {
                        tipoReporte.value === "ventaMensual" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    <ChartFromServer
                                        setAuxData={null}
                                        apiService={Api.GraficaVentasTotalesMes}
                                        args={{ token: token }}
                                        conditions={true}
                                        type="LinealMultiAxis"
                                        idContent={"GraficaVentasTotalesMes" + tipoReporte.value}
                                        dataSeries={dataSeries}
                                        colorList={colorList}
                                        settings={settings}
                                        classContent="chart400Height"
                                        setEnableQuery={null}
                                    >
                                    </ChartFromServer>
                                </div>
                            </>
                        )
                    }
                    {
                        tipoReporte.value === "ventaMensualM2" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    <ChartFromServer
                                        setAuxData={null}
                                        apiService={Api.GraficaVentasTotalesMesM2}
                                        args={{ token: token }}
                                        conditions={true}
                                        type="LinealMultiAxis"
                                        idContent={"GraficaVentasTotalesMes" + tipoReporte.value}
                                        dataSeries={dataSeries}
                                        colorList={colorList}
                                        settings={settings}
                                        classContent="chart400Height"
                                        setEnableQuery={null}
                                    >
                                    </ChartFromServer>
                                </div>
                            </>
                        )
                    }
                </div>
            </PermissionsGate>
        </>
    )
}